import { ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api';

const REGENERATE_DEVICE_PREVIEW_URL = '/templates/retest';

export const useRegenerateDevicePreviews = (
  params: Record<string, string>,
  options?: UseRestMutationOptions,
) => {
  const queryParams = new URLSearchParams(params);

  const { mutate, isLoading, error } = useRestMutation(
    `${REGENERATE_DEVICE_PREVIEW_URL}?${queryParams.toString()}`,
    ApiMethod.post,
    options,
  );

  return {
    mutate,
    isLoading,
    error,
  };
};
